export default "__VITE_ASSET__DLBEQhSk__"